"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhoneNumbers = exports.editPhoneNumbers = exports.deletePhoneNumber = exports.default = exports.addPhoneNumber = void 0;
var _mainConfig = require("../mainConfig");
var _phoneNumbersApi = _interopRequireDefault(require("../cic/api/phoneNumbersApi"));
var _myDataApi = _interopRequireDefault(require("../csc/api/myDataApi"));
var currentApiSet = _mainConfig.isCICContentTree ? _phoneNumbersApi.default : _myDataApi.default;
var getPhoneNumbers = exports.getPhoneNumbers = currentApiSet.getPhoneNumbers,
  addPhoneNumber = exports.addPhoneNumber = currentApiSet.addPhoneNumber,
  editPhoneNumbers = exports.editPhoneNumbers = currentApiSet.editPhoneNumbers,
  deletePhoneNumber = exports.deletePhoneNumber = currentApiSet.deletePhoneNumber;
var _default = exports.default = currentApiSet;